import { ChangeDetectorRef, Directive, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CreditCard } from '@df/session/api/credit-cards/credit-card';
import { Customer } from '@df/session/api/customer';
import { CustomerModel } from '@df/session/api/customer.model';
import { Subscription } from 'rxjs';

@Directive()
export abstract class AccountSavedCardsComponentDef implements OnInit, OnDestroy {
    protected subscriptions: Subscription = new Subscription();

    /**
     * Customer model
     */
    customerModel: CustomerModel;

    /**
     * Form
     */
    @ViewChild('form', { static: false })
    form?: NgForm;

    /**
     * Class constructor
     */
    constructor(
        protected _ref: ChangeDetectorRef,
        customer: Customer
    ) {
        this.customerModel = customer.model;
    }

    /**
     * On init hook to set up subscription
     */
    ngOnInit() {
        this.subscriptions.add(this.customerModel.obs.data.subscribe(() => this._ref.detectChanges()));
    }

    /**
     * On destroy callback
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Tracking method
     */
    trackByCardHash(index: number, card: CreditCard): string {
        return card.data.public_hash;
    }
}
